import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const InvoiceButton = styled(Button)(({ theme }) => ({
  background: "#FFFFFF",
  border: "1px solid #858585",
  borderRadius: "4px",
  padding: "6px",
  minWidth: "fit-content",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "17px",
  lineHeight: "16px",
  color: "rgba(11, 11, 11, 0.5)",
  textTransform: "capitalize",
  fontFamily: theme.typography.fontFamily,
  height: "40px",
  "& img": {
    marginRight: "5px",
  },
  "& svg": {
    marginRight: "5px",
    fontSize: "20px",
  },
  "&:hover": {
    background: "#FFFFFF",
  },
}));

const AccountingHeader = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "20px",
  alignItems: "center",
}));

export { InvoiceButton, AccountingHeader };
